import { render, staticRenderFns } from "./ProjectPackage.vue?vue&type=template&id=28b4b969&"
import script from "./ProjectPackage.vue?vue&type=script&lang=js&"
export * from "./ProjectPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports